import React, { useRef } from "react"
import { Modal, Typography, Space, Button, message } from "@mimber/ui-web"
import { useDeleteDonationPage } from "@mimber/client/mimber-organization"
import type { DeleteDonationPageModalProps } from "./DeleteDonationPageModal.types"

const { Text, Paragraph } = Typography

export const DeleteDonationPageModal: React.FunctionComponent<
  DeleteDonationPageModalProps
> = ({ donationPage, onSuccess, ...modalProps }) => {
  const closeRef = useRef<(() => void) | null>(null)

  const mutation = useDeleteDonationPage(donationPage.uuid, {
    onSuccess: () => {
      message.success("Donation page deleted")
      closeRef.current?.()
      onSuccess?.()
    },
    onError: (error) => {
      message.error(`Failed to delete donation page: ${error.message}`)
    },
  })

  return (
    <Modal title="Delete Donation Page" footer={null} {...modalProps}>
      {(close) => {
        closeRef.current = close
        return (
          <Space orientation="vertical" size="large" style={{ width: "100%" }}>
            <Paragraph>
              Are you sure you want to delete{" "}
              <Text strong>{donationPage.title}</Text>?
            </Paragraph>
            <Paragraph type="secondary">
              This action cannot be undone.
            </Paragraph>
            <Space style={{ justifyContent: "flex-end", width: "100%" }}>
              <Button onClick={close} disabled={mutation.isPending}>
                Cancel
              </Button>
              <Button
                type="primary"
                danger
                loading={mutation.isPending}
                onClick={() => mutation.mutate()}
              >
                Delete Donation Page
              </Button>
            </Space>
          </Space>
        )
      }}
    </Modal>
  )
}
